import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private baseUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    }
  }

  getBaseUrl(): string {
    return this.baseUrl;
  }

  generateCertificate(payload: any) {
    return this.http.post(`${this.baseUrl}/certificates/generate`, payload, {
      ...this.getAuthHeaders(),
      responseType: 'blob'
    });
  }
}